module.exports = __webpack_public_path__ + "static/media/Yogurt.c0ce39ad.jpg";